import { useRef, useState } from 'react';
import { LITTLE_THINGS } from '../content/siteContent';
import Seo from "./Seo";

function Piece({ piece }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const bodyClass = piece.type === 'poem' ? 'lt-poem' : 'lt-prose';
    return (
        <div className="lt-piece">
            {piece.title && <p className="lt-title">{piece.title}</p>}
            <p className={bodyClass}>{piece.preview}</p>
            {piece.rest && (
                <>
                    <div className="lt-rest" ref={ref}
                        style={{ maxHeight: open && ref.current ? ref.current.scrollHeight : 0, opacity: open ? 1 : 0 }}>
                        <p className={bodyClass}>{piece.rest}</p>
                    </div>
                    <button className="lt-more" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
                        {open ? 'close' : (piece.type === 'poem' ? 'read on →' : 'read the rest →')}
                    </button>
                </>
            )}
            {piece.date && <p className="lt-meta">{piece.date}</p>}
        </div>
    );
}

export default function LittleThings() {
    const pieces = LITTLE_THINGS;

    return (
        <main className="cx-page"><div className="cx-col">
            <Seo title="little things" path="/little-things"
                 description="Poems, fragments, and small prose." />

            <div className="cx-fade">
                <div className="lt-head">
                    <h1>little things</h1>
                    <p className="intro">A collection of poems, fragments, and prose that remind me to appreciate the beautiful little things</p>
                </div>

                {pieces.length > 0 && (
                    <>
                        <div className="lt-fleuron">{'\u2766'}</div>
                        {pieces.map((p, i) => (
                            <div key={i}>
                                <Piece piece={p} />
                                <div className="lt-fleuron">{'\u2766'}</div>
                            </div>
                        ))}
                    </>
                )}
            </div>
        </div></main>
    );
}
